/**
 * redesk-pro-list.js
 * Liste "espace pro" : aucune écriture panier Shopify. Tout vit dans
 * localStorage, clé REDESK_STORAGE_KEY, forme :
 *   { [variantId]: { qty, max, title, priceHt, priceTtc } }
 * (prix en centimes, cohérents avec les attributs data-price-* du markup ;
 * max = stock réel de la variante, plafond des quantités).
 */
(function () {
  var STORAGE_KEY = 'redesk_pro_list';
  /* ponytail: plafond de secours quand le stock d'une variante est inconnu
     (variante non suivie par Shopify ou vue pro-inventory indisponible). */
  var MAX_QTY_FALLBACK = 999;

  /* Mesure. Le stub PostHog de layout/pro.liquid empile les appels faits avant
     l'init differe, donc on peut tracker des la premiere seconde sans rien perdre.
     Enveloppe par securite : une page servie sans le stub ne doit pas casser. */
  function track(name, props) {
    try {
      if (window.posthog && window.posthog.capture) {
        window.posthog.capture(name, props || {});
      }
    } catch (error) {
      /* la mesure ne casse jamais le parcours. */
    }
  }

  // Ouverture d'une question d'aide : « toggle » ne remonte pas, d'où la capture.
  document.addEventListener('toggle', function (event) {
    var el = event.target;
    if (el.open && el.hasAttribute && el.hasAttribute('data-fam-help-q')) {
      track('pro_help_open', { famille: el.getAttribute('data-fam-help-q') });
    }
  }, true);

  /* Source d'arrivée du visiteur, recopiée en attributs du draft par n8n
     (assets/redesk-datalayer.js). */
  function attributionDevis() {
    return window.RedeskDL && window.RedeskDL.attribution ? window.RedeskDL.attribution() : {};
  }

  function readList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function writeList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      /* localStorage indisponible (navigation privée, quota) : on ignore. */
    }
  }

  /* La quantité passée REMPLACE celle déjà en liste, elle ne s'y ajoute pas
     (issue #59).

     Le cumul était le pire des deux comportements : il additionnait sans le
     dire. Article en liste à 1, stepper de la fiche réglé sur 3, clic
     « Ajouter » : le récap affichait 4 et la fiche continuait d'afficher 3.
     Deux chiffres contradictoires à l'écran pour le même produit, sur des
     devis à quatre chiffres.

     Le remplacement supprime la contradiction PAR CONSTRUCTION, et non par
     synchronisation : le stepper d'une ligne déjà en liste s'ouvre prérempli à
     la quantité en liste (voir syncRowStates()), donc la valeur affichée avant
     le clic est exactement celle qui sera écrite. Effet de bord précieux :
     l'action devient idempotente, un double clic, une double soumission ou un
     lien ?l= rejoué ne gonflent plus la liste en silence.

     Coût assumé : « j'en veux 3 de plus » demande de monter le stepper de 3 à
     5 au lieu de saisir 3. Acceptable, puisque le stepper part désormais de la
     quantité courante et non de 1. */
  function addItem(variantId, qty, meta) {
    var list = readList();
    var key = String(variantId);
    var safeQty = parseInt(qty, 10) || 1;
    var max = (meta && parseInt(meta.max, 10)) || MAX_QTY_FALLBACK;

    list[key] = {
      qty: Math.min(safeQty, max),
      max: max,
      title: (meta && meta.title) || '',
      priceHt: (meta && parseInt(meta.priceHt, 10)) || 0,
      priceTtc: (meta && parseInt(meta.priceTtc, 10)) || 0
    };

    writeList(list);
    renderRecap();
    return list[key];
  }

  function removeItem(variantId) {
    var list = readList();
    delete list[String(variantId)];
    writeList(list);
    renderRecap();
  }

  /* Totaux seuls, sans toucher au DOM : renderRecap() repeint le recap, et
     l'appeler juste pour mesurer ajouterait un rendu a chaque ajout. */
  function listTotals() {
    var list = readList();
    var totalQty = 0;
    var totalHt = 0;
    Object.keys(list).forEach(function (key) {
      totalQty += list[key].qty;
      totalHt += list[key].qty * list[key].priceHt;
    });
    return { totalQty: totalQty, totalHt: totalHt };
  }

  function renderRecap() {
    var list = readList();
    var keys = Object.keys(list);
    var totals = listTotals();
    var totalQty = totals.totalQty;
    var totalHt = totals.totalHt;

    var recap = document.querySelector('.redesk-pro-list__recap');
    if (recap) {
      recap.setAttribute('data-item-count', String(keys.length));
      recap.setAttribute('data-total-qty', String(totalQty));
      recap.setAttribute('data-total-ht', String(totalHt));
    }

    var detail = { list: list, itemCount: keys.length, totalQty: totalQty, totalHt: totalHt };
    document.dispatchEvent(new CustomEvent('redesk-pro-list:updated', { detail: detail }));
    return detail;
  }

  function clampQty(value, max) {
    var parsed = parseInt(value, 10);
    if (!parsed || parsed < 1) {
      return 1;
    }
    var ceiling = parseInt(max, 10) || MAX_QTY_FALLBACK;
    return Math.min(parsed, ceiling);
  }

  function setQty(variantId, qty) {
    var list = readList();
    var key = String(variantId);
    if (!list[key]) {
      return;
    }
    list[key].qty = clampQty(qty, list[key].max);
    writeList(list);
    renderRecap();
  }

  /* ---------- Lien de reprise de liste ----------
     L'URL EST le stockage : ?l=<variantId>x<qty>-<variantId>x<qty>. Le pro met
     sa liste en favori, l'envoie à son responsable, la réouvre sur un autre
     appareil, et le commercial ouvre exactement le même écran pendant l'appel.
     Aucun compte, aucune app, aucun stockage serveur.
     ponytail: ~350 caractères pour 20 lignes, largement sous les limites d'URL.
     Si une liste devait déborder, passer à un identifiant court côté flow. */

  function buildListUrl() {
    var list = readList();
    var code = Object.keys(list).map(function (id) {
      return id + 'x' + list[id].qty;
    }).join('-');
    var base = window.location.origin + window.location.pathname;
    return code ? base + '?l=' + code : base;
  }

  function parseListParam() {
    var match = window.location.search.match(/[?&]l=([^&]+)/);
    if (!match) {
      return null;
    }
    var wanted = {};
    decodeURIComponent(match[1]).split('-').forEach(function (pair) {
      var parts = pair.split('x');
      var id = (parts[0] || '').replace(/\D/g, '');
      var qty = parseInt(parts[1], 10);
      if (!id) {
        return;
      }
      // Identifiant valide mais quantité illisible : on garde l'article à 1
      // plutôt que de le perdre en silence (QA 2026-07-28).
      wanted[id] = qty > 0 ? qty : 1;
    });
    return Object.keys(wanted).length ? wanted : null;
  }

  // Réhydrate APRÈS le rendu du catalogue : les métadonnées (titre, prix,
  // plafond de stock) sont lues sur la ligne rendue, donc une référence
  // disparue ou épuisée est simplement ignorée au lieu d'être ressuscitée.
  // Fusion par le max avec la liste en cours : ouvrir un lien n'efface jamais
  // une liste déjà composée.
  // Retire `l` de la barre d'adresse une fois l'import fait. Sans ça la fusion
  // par le maximum se rejoue à chaque chargement : une ligne supprimée
  // ressuscite au premier F5 et une quantité baissée remonte, donc la liste ne
  // peut plus que grandir (QA 2026-07-28).
  function dropListParam() {
    if (!window.history || !window.history.replaceState) {
      return;
    }
    var search = window.location.search
      .replace(/([?&])l=[^&]*/, '$1')
      .replace(/[?&]$/, '')
      .replace(/\?&/, '?')
      .replace(/&&/g, '&');
    if (search === '?' || search === '&') {
      search = '';
    }
    window.history.replaceState({}, '', window.location.pathname + search + window.location.hash);
  }

  function hydrateFromUrl(section) {
    var wanted = parseListParam();
    if (!wanted) {
      return;
    }
    var list = readList();
    var loaded = 0;

    Object.keys(wanted).forEach(function (id) {
      var row = section.querySelector('.redesk-pro-list__row[data-variant-id="' + id + '"]');
      if (!row) {
        return;
      }
      var max = parseInt(row.getAttribute('data-max'), 10) || 1;
      var previous = list[id] ? list[id].qty : 0;
      list[id] = {
        qty: Math.min(Math.max(previous, wanted[id]), max),
        max: max,
        title: row.getAttribute('data-title') || '',
        priceHt: parseInt(row.getAttribute('data-price-ht'), 10) || 0,
        priceTtc: parseInt(row.getAttribute('data-price-ttc'), 10) || 0
      };
      loaded += 1;
    });

    if (loaded) {
      writeList(list);
      renderRecap();
    }
    // Systématique, même si rien n'a été chargé : le paramètre ne doit jamais
    // survivre à un chargement.
    dropListParam();
  }

  function copyText(text) {
    if (window.navigator && window.navigator.clipboard && window.navigator.clipboard.writeText) {
      return window.navigator.clipboard.writeText(text);
    }
    // Repli pour les contextes sans Clipboard API (http, vieux Safari).
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', 'readonly');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (error) {
      ok = false;
    }
    document.body.removeChild(field);
    return ok ? Promise.resolve() : Promise.reject(new Error('copy'));
  }

  /* ---------- Partage de liste (issue #66) ----------
     buildListUrl() existait depuis le début et partait déjà dans le mail, mais
     rien ne l'exposait à l'écran : le pro qui doit faire valider sa sélection
     ne pouvait que recopier l'URL de la barre d'adresse. Or environ 88 % des
     achats B2B impliquent au moins deux personnes, donc la liste circule de
     toute façon.
     La mesure passe par listTotals(), jamais par renderRecap() : mesurer ne
     doit pas repeindre le récap. */

  function buildMailtoHref(url, totals) {
    var pluriel = totals.totalQty > 1 ? 's' : '';
    var corps = [
      'Bonjour,',
      '',
      "Voici la liste de mobilier que j'ai préparée sur Redesk (" +
        totals.totalQty + ' article' + pluriel + ', ' + formatCents(totals.totalHt) + ' HT) :',
      url,
      '',
      'Ce lien rouvre la liste telle quelle, quantités comprises.'
    ].join('\r\n');
    return 'mailto:?subject=' + encodeURIComponent('Ma sélection de mobilier Redesk') +
      '&body=' + encodeURIComponent(corps);
  }

  /* Repli lisible quand le presse-papier est refusé : hors HTTPS, en vieux
     Safari, ou quand l'utilisateur refuse la permission, navigator.clipboard
     n'existe pas ou rejette. Laisser « Copie impossible » donnerait un bouton
     mort : on affiche le lien en clair, sélectionné, prêt à être recopié. */
  function revealShareFallback(scope, url) {
    var champ = scope ? scope.querySelector('[data-share-url]') : null;
    if (!champ) {
      return false;
    }
    var bloc = scope.querySelector('[data-share-fallback]');
    if (bloc) {
      bloc.hidden = false;
    }
    champ.value = url;
    if (champ.focus) {
      champ.focus();
    }
    if (champ.select) {
      champ.select();
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-copy-link]') : null;
    if (!btn) {
      return;
    }
    var url = buildListUrl();
    var totals = listTotals();
    track('pro_list_share', {
      nb_articles: totals.totalQty,
      total_ht: totals.totalHt,
      methode: 'copie'
    });
    var scope = btn.closest ? btn.closest('[data-share]') : null;
    var initial = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', initial);
    copyText(url)
      .then(function () {
        btn.textContent = 'Lien copié';
      })
      .catch(function () {
        btn.textContent = revealShareFallback(scope, url) ? 'Copiez le lien ci-dessous' : 'Copie impossible';
      })
      .then(function () {
        window.setTimeout(function () {
          btn.textContent = initial;
        }, 4000);
      });
  });

  // Le mailto : son href est tenu à jour par updateRecapUI(), donc il reste
  // bon même si ce gestionnaire n'a jamais tourné. Ici on ne fait que mesurer.
  document.addEventListener('click', function (event) {
    var lien = event.target && event.target.closest ? event.target.closest('[data-share-mail]') : null;
    if (!lien) {
      return;
    }
    var totaux = listTotals();
    track('pro_list_share', {
      nb_articles: totaux.totalQty,
      total_ht: totaux.totalHt,
      methode: 'mail'
    });
  });

  function formatCents(cents) {
    var value = Math.round((cents || 0) / 100);
    var sign = value < 0 ? '-' : '';
    var absValue = Math.abs(value);
    var formatted = String(absValue).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return sign + formatted + ' €';
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildRitemMarkup(variantId, item) {
    return (
      '<div class="redesk-pro-list__ritem" data-variant-id="' + escapeHtml(variantId) + '">' +
        '<div class="redesk-pro-list__ritem-stepper">' +
          '<button type="button" class="redesk-pro-list__ritem-step" data-recap-step="minus" aria-label="Diminuer la quantité">&minus;</button>' +
          '<span class="redesk-pro-list__ritem-qty">' + item.qty + '</span>' +
          '<button type="button" class="redesk-pro-list__ritem-step" data-recap-step="plus" aria-label="Augmenter la quantité">+</button>' +
        '</div>' +
        '<span class="redesk-pro-list__ritem-name">' + escapeHtml(item.title) + '</span>' +
        '<span class="redesk-pro-list__ritem-price">' + formatCents(item.qty * item.priceHt) + '</span>' +
        '<button type="button" class="redesk-pro-list__ritem-remove" data-recap-remove aria-label="Retirer ' + escapeHtml(item.title) + '">&times;</button>' +
      '</div>'
    );
  }

  function updateRecapUI(detail) {
    var recap = document.querySelector('.redesk-pro-list__recap');
    var mbar = document.querySelector('[data-mbar]');
    if (!recap && !mbar) {
      return;
    }

    var list = detail.list;
    var keys = Object.keys(list);

    if (recap) {
      var body = recap.querySelector('[data-recap-body]');
      var sub = recap.querySelector('[data-recap-sub]');
      var qtyEl = recap.querySelector('[data-recap-qty]');
      var totalEl = recap.querySelector('[data-recap-total]');
      var quoteBtn = recap.querySelector('[data-quote-open]');

      if (body) {
        if (keys.length === 0) {
          body.innerHTML = '<div class="redesk-pro-list__recap-empty" data-recap-empty>Votre liste est vide.<br>Ajoutez du mobilier depuis le catalogue.</div>';
        } else {
          body.innerHTML = keys.map(function (key) {
            return buildRitemMarkup(key, list[key]);
          }).join('');
        }
      }
      if (sub) {
        sub.textContent = detail.totalQty > 0
          ? detail.totalQty + ' article' + (detail.totalQty > 1 ? 's' : '')
          : 'Aucun article';
      }
      if (qtyEl) {
        qtyEl.textContent = String(detail.totalQty);
      }
      if (totalEl) {
        totalEl.textContent = formatCents(detail.totalHt);
      }
      if (quoteBtn) {
        quoteBtn.disabled = detail.itemCount === 0;
      }
      // Partage : rien à partager tant que la liste est vide. Le mailto est
      // reconstruit à chaque changement, donc il porte toujours la liste à jour
      // même si l'utilisateur clique tout de suite après un ajout.
      var copyBtn = recap.querySelector('[data-copy-link]');
      if (copyBtn) {
        copyBtn.hidden = detail.itemCount === 0;
      }
      var mailLink = recap.querySelector('[data-share-mail]');
      if (mailLink) {
        mailLink.hidden = detail.itemCount === 0;
        mailLink.setAttribute('href', buildMailtoHref(buildListUrl(), {
          totalQty: detail.totalQty,
          totalHt: detail.totalHt
        }));
      }
      // Le repli affiche une URL figée : la liste ayant changé, on le referme.
      var fallback = recap.querySelector('[data-share-fallback]');
      if (fallback) {
        fallback.hidden = true;
      }
    }

    // Compteur cherché dans TOUT le document, pas dans [data-mbar] : le même
    // compteur est rendu deux fois, dans la barre mobile et dans le bouton
    // « Ma liste » du header, qui vit dans layout/pro.liquid donc hors de la
    // barre et hors de la section. Scopé, le second n'aurait jamais bougé.
    var compteurs = document.querySelectorAll('[data-mbar-count]');
    for (var c = 0; c < compteurs.length; c += 1) {
      compteurs[c].textContent = String(detail.totalQty);
    }

    if (mbar) {
      var mTotal = mbar.querySelector('[data-mbar-total]');
      var mBtn = mbar.querySelector('[data-quote-open]');
      if (mTotal) {
        mTotal.textContent = formatCents(detail.totalHt);
      }
      if (mBtn) {
        mBtn.disabled = detail.itemCount === 0;
      }
    }
  }

  function initRecapInteractions() {
    var recap = document.querySelector('.redesk-pro-list__recap');
    if (!recap) {
      return;
    }

    recap.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('[data-recap-remove]');
      if (removeBtn) {
        var removeRow = removeBtn.closest('[data-variant-id]');
        if (removeRow) {
          removeItem(removeRow.getAttribute('data-variant-id'));
        }
        return;
      }

      var stepBtn = event.target.closest('[data-recap-step]');
      if (stepBtn) {
        var row = stepBtn.closest('[data-variant-id]');
        if (!row) {
          return;
        }
        var variantId = row.getAttribute('data-variant-id');
        var list = readList();
        var current = list[variantId] ? list[variantId].qty : 1;
        var direction = stepBtn.getAttribute('data-recap-step') === 'plus' ? 1 : -1;
        var nextQty = current + direction;

        // Le « − » du récap s'arrête à 1, exactement comme celui du catalogue
        // (issue #59). Il supprimait jusque-là la ligne sans rien demander :
        // deux comportements opposés pour le même bouton, dont l'un détruisait
        // une ligne de devis sur un clic de trop. On ne lui ajoute pas une
        // confirmation, on lui retire le pouvoir de supprimer : le « × » juste
        // à côté est déjà là pour ça, et il est explicite.
        if (nextQty >= 1) {
          setQty(variantId, nextQty);
        }
      }
    });
  }

  document.addEventListener('redesk-pro-list:updated', function (event) {
    updateRecapUI(event.detail);
    // Unique point de repeinte des lignes du catalogue : toute écriture dans la
    // liste passe par renderRecap(), qui émet cet événement. Ajout, retrait,
    // stepper du récap, import ?l= : les lignes suivent, sans un seul appel
    // supplémentaire disséminé dans le fichier.
    syncRowStates(document);
  });

  /* ---------- Récap déplié en panneau (issue #69) ----------
     Sous 1080 px, le récap était masqué en display:none, et c'est le seul
     endroit du DOM qui porte les lignes, les steppers et les suppressions :
     on envoyait sa demande sans pouvoir la relire. La barre mobile devient
     donc le déclencheur d'un panneau plein écran sur ce même récap. Aucun
     DOM dupliqué, aucun handler dupliqué : les interactions du récap sont
     déjà câblées par initRecapInteractions(). */
  var RECAP_PANEL_BREAKPOINT = 1080;

  function initRecapPanel(section) {
    // querySelectorAll, et sur le document : deux boutons portent ce rôle, la
    // barre mobile dans la section et « Ma liste » dans le header, qui vit
    // dans layout/pro.liquid donc hors de la section. Au singulier et scopé,
    // le bouton du header serait inerte, sans la moindre erreur en console.
    var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-recap-toggle]'));
    var recap = section.querySelector('.redesk-pro-list__recap');
    if (!toggles.length || !recap) {
      return null;
    }
    var closeBtn = recap.querySelector('[data-recap-close]');
    var previousBodyOverflow = '';
    // Le déclencheur qui a ouvert le panneau : c'est à lui que le focus
    // revient à la fermeture, pas systématiquement au premier du document.
    var lastToggle = toggles[0];

    function isOpen() {
      return section.classList.contains('is-recap-open');
    }

    // Le récap n'est un panneau dépliable que sous 1080 px. Au-dessus c'est
    // une colonne permanente : le bouton y fait défiler jusqu'à elle, et
    // aria-expanded n'a alors aucun sens, donc l'attribut est retiré.
    function isPanelMode() {
      return window.innerWidth <= RECAP_PANEL_BREAKPOINT;
    }

    function syncToggles() {
      var panel = isPanelMode();
      var ouvert = isOpen();
      toggles.forEach(function (toggle) {
        if (!panel) {
          toggle.removeAttribute('aria-expanded');
        } else if (ouvert) {
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          toggle.setAttribute('aria-expanded', 'false');
        }
        var label = toggle.querySelector('[data-recap-toggle-label]');
        if (label) {
          label.textContent = ouvert ? 'Fermer ma liste' : 'Voir et modifier ma liste';
        }
      });
    }

    function open() {
      if (isOpen()) {
        return;
      }
      section.classList.add('is-recap-open');
      syncToggles();
      // Le rôle de dialogue n'est vrai que replié en panneau : au-dessus de
      // 1080 px le récap est une colonne permanente, l'annoncer comme un
      // dialogue mentirait au lecteur d'écran.
      recap.setAttribute('role', 'dialog');
      recap.setAttribute('aria-modal', 'true');
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      var target = closeBtn || recap;
      if (!closeBtn) {
        recap.setAttribute('tabindex', '-1');
      }
      if (target.focus) {
        target.focus();
      }
    }

    function close(options) {
      if (!isOpen()) {
        return;
      }
      section.classList.remove('is-recap-open');
      syncToggles();
      recap.removeAttribute('role');
      recap.removeAttribute('aria-modal');
      document.body.style.overflow = previousBodyOverflow;
      // Le focus revient au bouton qui a ouvert le panneau, pas au premier du
      // document : on est venu par le header, on y retourne.
      var toggle = lastToggle || toggles[0];
      if (!(options && options.keepFocus) && toggle && toggle.focus) {
        toggle.focus();
      }
    }

    // Au-dessus de 1080 px il n'y a rien à déplier : le récap est déjà là,
    // mais 850 lignes de catalogue l'ont fait sortir de l'écran. On y amène
    // l'utilisateur et on lui donne le focus, sans mentir sur un panneau.
    function revealRecap() {
      if (recap.scrollIntoView) {
        recap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      recap.setAttribute('tabindex', '-1');
      if (recap.focus) {
        recap.focus();
      }
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        lastToggle = toggle;
        if (isPanelMode() && isOpen()) {
          close();
          return;
        }
        // Mesure du seul accès du header (issue #59) : combien de pros
        // reviennent à leur liste depuis le haut de page, et avec combien
        // d'articles. Totaux via listTotals(), jamais renderRecap() qui
        // repeindrait le récap pour une simple lecture.
        if (toggle.hasAttribute('data-pro-header-list')) {
          track('pro_header_list_open', { nb_articles: listTotals().totalQty });
        }
        if (isPanelMode()) {
          open();
        } else {
          revealRecap();
        }
      });
    });

    syncToggles();

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !isOpen()) {
        return;
      }
      // La modale de devis se ferme la première : elle est au-dessus.
      if (section.querySelector('.redesk-pro-list__sheet.is-open')) {
        return;
      }
      close();
    });

    // Passage en desktop pendant que le panneau est ouvert : le récap y est
    // une colonne normale, laisser la classe et le scroll bloqué figerait la
    // page. On ne vole pas le focus dans ce cas, l'utilisateur n'a rien fait.
    window.addEventListener('resize', function () {
      if (isOpen() && !isPanelMode()) {
        close({ keepFocus: true });
      }
      // Le récap change de nature au passage du seuil : aria-expanded doit
      // apparaître ou disparaître avec lui, sinon un lecteur d'écran annonce
      // un panneau repliable là où il n'y a qu'une colonne.
      syncToggles();
    });

    return { open: open, close: close, isOpen: isOpen };
  }

  // Un bornage silencieux fabrique des devis faux : l'acheteur qui demande
  // 8 chaises pour 8 postes doit apprendre qu'il n'en obtiendra que 4, et que
  // le conseiller peut en chercher davantage (aucune réservation, cf. ADR-0005).
  function showClampNotice(row, allowed) {
    if (!row) {
      return;
    }
    var notice = row.querySelector('[data-clamp-notice]');
    if (!notice) {
      return;
    }
    // Expliquer la CORRECTION, pas répéter le badge de stock affiché juste
    // au-dessus : le pro a saisi 40, sa valeur est devenue 2, c'est ça qu'il
    // faut lui dire. Le renvoi au conseiller applique l'ADR-0005 : rien n'est
    // réservé, c'est un humain qui arbitre s'il faut davantage d'exemplaires.
    notice.textContent = 'Quantité ramenée à ' + allowed + ', le maximum en stock. ' +
      'Dites-le au conseiller s\'il vous en faut plus.';
    notice.hidden = false;
    row.setAttribute('data-was-clamped', '1');
  }

  function hideClampNotice(row) {
    if (!row) {
      return;
    }
    var notice = row.querySelector('[data-clamp-notice]');
    if (notice) {
      notice.hidden = true;
      notice.textContent = '';
    }
    row.removeAttribute('data-was-clamped');
  }

  function initSteppers(scope) {
    var steppers = scope.querySelectorAll('[data-stepper]');
    steppers.forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty]');
      var minusBtn = stepper.querySelector('[data-step="minus"]');
      var plusBtn = stepper.querySelector('[data-step="plus"]');
      if (!input || !minusBtn || !plusBtn) {
        return;
      }
      var row = stepper.closest('.redesk-pro-list__row');
      var max = row ? row.getAttribute('data-max') : null;

      // Les bornes doivent se VOIR : un bouton qui ne fait rien sans le dire
      // laisse croire à un bug (QA 2026-07-28).
      function syncBounds() {
        var current = parseInt(input.value, 10) || 1;
        var ceiling = parseInt(max, 10) || 1;
        minusBtn.disabled = current <= 1;
        plusBtn.disabled = current >= ceiling;
      }

      // Les boutons ne peuvent pas dépasser le plafond (le `+` se désactive),
      // donc ils n'ont jamais à avertir : ils doivent en revanche RETIRER un
      // avertissement laissé par une saisie précédente (QA 2026-07-30).
      minusBtn.addEventListener('click', function () {
        input.value = Math.max(1, clampQty(input.value, max) - 1);
        syncBounds();
        hideClampNotice(row);
      });
      plusBtn.addEventListener('click', function () {
        input.value = clampQty(parseInt(input.value, 10) + 1 || 1, max);
        syncBounds();
        hideClampNotice(row);
      });

      // L'avertissement s'affiche À LA FRAPPE, sans toucher à la valeur.
      // Raison : l'afficher au moment du clic sur « Ajouter » faisait grandir la
      // ligne entre le mousedown et le mouseup, le bouton passait sous le
      // curseur, et le navigateur n'émettait alors AUCUN click. L'ajout était
      // perdu et il fallait cliquer deux fois (régression constatée en QA le
      // 2026-07-30). En avertissant pendant la saisie, le décalage de mise en
      // page a lieu bien avant que l'utilisateur ne visse le bouton.
      input.addEventListener('input', function () {
        var asked = parseInt(input.value, 10);
        var ceiling = parseInt(max, 10) || 1;
        if (asked > ceiling) {
          showClampNotice(row, ceiling);
        } else {
          hideClampNotice(row);
        }
      });
      // `change` ne fait que corriger la valeur. L'avertissement a déjà été posé
      // par l'écouteur `input` ci-dessus, on ne le crée pas ici pour ne pas
      // décaler la mise en page au moment du clic. On le retire seulement si la
      // valeur finale est valide (cas d'une saisie corrigée avant de sortir).
      input.addEventListener('change', function () {
        var asked = parseInt(input.value, 10) || 1;
        var allowed = clampQty(input.value, max);
        input.value = allowed;
        syncBounds();
        if (asked <= allowed) {
          hideClampNotice(row);
        }
      });
      syncBounds();
    });
  }

  /* Le bouton d'ajout porte UN SEUL libellé, « Ajouter », rendu à l'identique
     par les deux rendus de ligne et jamais réécrit ici. Un bouton dont le mot
     change sous les yeux oblige à le lire pour connaître l'état, alors que
     l'état est déjà porté par le badge de la ligne.

     Cette fonction ne règle donc qu'une chose : le bouton est désactivé quand
     la quantité DÉJÀ en liste atteint le stock disponible. C'est le seul cas où
     cliquer ne peut rien produire, et c'est un fait de stock, pas une nuance
     d'interface. Le `title` dit pourquoi, sinon un bouton grisé sans raison est
     aussi frustrant qu'un bouton inerte. */
  function refreshAddButton(row, entry) {
    var addBtn = row.querySelector('[data-add]');
    if (!addBtn) {
      return;
    }
    var max = parseInt(row.getAttribute('data-max'), 10);
    var sature = !!entry && entry.qty > 0 && max > 0 && entry.qty >= max;
    if (addBtn.disabled !== sature) {
      addBtn.disabled = sature;
    }
    if (sature) {
      addBtn.setAttribute('title', 'Stock maximum déjà dans votre liste');
    } else {
      addBtn.removeAttribute('title');
    }
  }

  /* Indicateur PERSISTANT « déjà dans ma liste » (issue #59).

     Avant : le bouton passait à « Ajouté ✓ » puis redevenait « Ajouter » au
     bout de deux secondes. Sur 850 références, plus rien ne signalait ce qui
     était déjà dans la liste, et on rajoutait le même article sans le savoir.

     L'état n'est jamais stocké dans le markup : il est DÉRIVÉ de localStorage
     à chaque fois. C'est ce qui le fait survivre au filtre, à la recherche, à
     la pagination, au remplacement complet du catalogue par le JS et au
     rechargement de page, sans aucune persistance supplémentaire.

     C'est aussi ce qui garantit la parité serveur / JS : les deux rendus de
     ligne (snippets/redesk-pro-row.liquid et buildRow()) émettent le MÊME
     markup inerte, badge masqué et stepper à 1, et cette unique fonction les
     hydrate tous les deux. Un seul chemin de code peint l'état. */
  function syncRowStates(scope) {
    var root = scope || document;
    var rows = (root.matches && root.matches('.redesk-pro-list__row[data-variant-id]'))
      ? [root]
      : root.querySelectorAll('.redesk-pro-list__row[data-variant-id]');
    var list = readList();

    Array.prototype.forEach.call(rows, function (row) {
      var entry = list[String(row.getAttribute('data-variant-id'))];
      var inList = !!entry && entry.qty > 0;
      var badge = row.querySelector('[data-inlist]');
      var input = row.querySelector('[data-qty]');

      if (inList) {
        row.setAttribute('data-in-list', String(entry.qty));
      } else {
        row.removeAttribute('data-in-list');
      }

      if (badge) {
        var texte = inList ? 'Dans ma liste : ' + entry.qty : '';
        if (badge.textContent !== texte) {
          badge.textContent = texte;
        }
        badge.hidden = !inList;
      }

      // Le stepper s'ouvre prérempli à la quantité en liste : c'est ce qui rend
      // le remplacement lisible, la valeur affichée avant le clic est celle qui
      // sera écrite. On ne touche pas à un champ en cours de saisie, sinon la
      // valeur sauterait sous les doigts à chaque mise à jour de la liste.
      if (input && inList && document.activeElement !== input) {
        var cible = String(entry.qty);
        if (input.value !== cible) {
          input.value = cible;
          // Réveille l'écouteur `change` du stepper, qui seul sait réactiver le
          // « − » et le « + » selon la nouvelle valeur.
          input.dispatchEvent(new Event('change'));
        }
      }

      refreshAddButton(row, entry);
    });
  }

  function initAddButtons(scope) {
    var rows = scope.querySelectorAll('.redesk-pro-list__row[data-variant-id]');
    rows.forEach(function (row) {
      var addBtn = row.querySelector('[data-add]');
      var qtyInput = row.querySelector('[data-qty]');
      if (!addBtn || !qtyInput) {
        return;
      }

      addBtn.addEventListener('click', function () {
        var variantId = row.getAttribute('data-variant-id');
        var asked = parseInt(qtyInput.value, 10) || 1;
        var qty = clampQty(qtyInput.value, row.getAttribute('data-max'));
        // Le bornage a pu être détecté et annoncé plus tôt par l'écouteur
        // `change` du stepper (le clic sur ce bouton fait perdre le focus au
        // champ, donc `change` passe avant nous et a déjà corrigé la valeur).
        // On relit son marqueur, et on couvre aussi le cas d'un bornage qui
        // n'aurait pas transité par `change`.
        var clamped = asked > qty || row.getAttribute('data-was-clamped') === '1';
        if (asked > qty) {
          showClampNotice(row, qty);
        }
        var meta = {
          title: row.getAttribute('data-title') || '',
          priceHt: row.getAttribute('data-price-ht'),
          priceTtc: row.getAttribute('data-price-ttc'),
          max: row.getAttribute('data-max')
        };

        addItem(variantId, qty, meta);
        track('pro_list_add', {
          variant_id: variantId,
          qty: qty,
          clamped: clamped,
          nb_articles: listTotals().totalQty
        });

        if (clamped) {
          qtyInput.value = qty;
        }

        // Aucun retour visuel temporisé ici : addItem() a émis
        // `redesk-pro-list:updated`, dont l'écouteur repeint toutes les lignes
        // via syncRowStates(). Le badge de la ligne s'allume, et il y reste tant
        // que l'article est en liste. Le
        // « Ajouté ✓ » qui s'effaçait au bout de deux secondes était justement
        // le défaut (issue #59).

        // Le filet exit-intent doit être armé tout de suite, dès le 1er article.
        syncExitIntent();
        // La règle des articles, elle, attend le retour visuel de l'ajout pour
        // ne pas voler la confirmation.
        window.setTimeout(function () {
          maybeOpenLeadSheet(false);
          syncExitIntent();
        }, clamped ? 2600 : 1000);
      });

    });
  }

  // "bureau" doit matcher "Bureau réglable" : minuscules + accents retirés.
  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  /* Filtres de l'outil (issue #102) : état et quantité disponible minimale.
     Décision pure, sans DOM : c'est elle que scripts/check-pro-filtres.mjs
     exécute sur des cas.

     La quantité se lit sur data-max, le plafond déjà porté par les deux rendus
     de ligne : le stock réel pour une variante suivie en politique « deny »,
     MAX_QTY_FALLBACK sinon. Une variante non suivie se vend sans plafond, elle
     passe donc tout seuil, ce qui est vrai. */
  function filterMatch(ligne, state) {
    if (state.minQty > 1 && !(ligne.max >= state.minQty)) { return false; }
    return true;
  }

  /* Recherche multi-mots (issue #101). Avant : sous-chaîne du seul titre,
     donc « bureau blanc » ne trouvait pas « Bureau droit 160 blanc », et rien
     ne cherchait dans la famille, l'état ou la référence. Désormais TOUS les
     mots doivent être présents, dans n'importe quel ordre, accents et casse
     ignorés, sur titre + famille + état + SKU. Trois fonctions pures, que
     scripts/check-pro-filtres.mjs exécute sur des cas. */
  function searchTerms(query) {
    return normalizeText(query).split(/\s+/).filter(Boolean);
  }

  function searchText(title, fam, etat, sku) {
    return normalizeText([title, fam, etat, sku].join(' '));
  }

  function searchMatch(texte, termes) {
    return termes.every(function (terme) { return texte.indexOf(terme) !== -1; });
  }

  // Ordre des états dans le filtre : les grades normalisés d'abord, du meilleur
  // au plus usé (_B, _C, _D du SKU), puis les libellés libres hérités, alpha.
  var ETAT_ORDRE = ['Neuf', 'Comme neuf', 'Très bon état', 'État correct', 'Fonctionnel'];

  function etatRank(etat) {
    var i = ETAT_ORDRE.indexOf(etat);
    return i === -1 ? ETAT_ORDRE.length : i;
  }

  // Onglets, filtres et recherche. Appelée deux fois : sur le premier écran
  // rendu côté serveur, puis sur le catalogue complet rendu par le JS. Les
  // écouteurs vivent sur des éléments qui survivent au remplacement (barre
  // collante, champ de recherche) : branchés une seule fois, ils relisent les
  // groupes à chaque application.
  function initFilters(scope) {
    var nav = scope.querySelector('[data-pro-nav]');
    var tabs = scope.querySelector('[data-filter-list]');
    var qtyInput = scope.querySelector('[data-filter-qty]');
    var searchInput = scope.querySelector('[data-search]');
    var clearBtn = scope.querySelector('[data-search-clear]');
    var countEl = scope.querySelector('[data-count]');
    var emptyMsg = scope.querySelector('[data-filter-empty]');
    var resetBtn = scope.querySelector('[data-filter-reset]');
    if (!scope.querySelector('.redesk-pro-list__cat')) {
      return;
    }

    if (scope.getAttribute('data-filters-bound') === '1') {
      // Le catalogue vient d'être remplacé : on réapplique l'état courant aux
      // nouveaux groupes, sans rebrancher d'écouteur.
      if (scope.__redeskApplyFilters) { scope.__redeskApplyFilters(); }
      return;
    }
    scope.setAttribute('data-filters-bound', '1');

    var state = { minQty: 0, terms: [] };

    function tabFor(fam) {
      if (!tabs) { return null; }
      var all = tabs.querySelectorAll('[data-cat-jump]');
      for (var i = 0; i < all.length; i++) {
        if (all[i].getAttribute('data-cat-jump') === fam) { return all[i]; }
      }
      return null;
    }

    function applyFilters() {
      var visible = 0;
      // Compteurs d'onglet écrits seulement sur le catalogue complet : sur le
      // premier écran, « Bureaux 5 » annoncerait un catalogue qui n'existe pas.
      var complet = scope.hasAttribute('data-catalog-complete');
      scope.querySelectorAll('.redesk-pro-list__cat').forEach(function (cat) {
        var n = 0;
        var fam = cat.getAttribute('data-category') || '';
        cat.querySelectorAll('.redesk-pro-list__row').forEach(function (row) {
          // Texte de recherche calculé une fois par ligne : les lignes sont
          // recréées au remplacement du catalogue, le cache part avec elles.
          if (row.__redeskSearch === undefined) {
            row.__redeskSearch = searchText(
              row.getAttribute('data-title'),
              fam,
              row.getAttribute('data-etat'),
              row.getAttribute('data-sku')
            );
          }
          var show = filterMatch({
            etat: row.getAttribute('data-etat') || '',
            max: parseInt(row.getAttribute('data-max'), 10) || 0
          }, state) && searchMatch(row.__redeskSearch, state.terms);
          row.style.display = show ? '' : 'none';
          if (show) {
            n++;
          }
        });
        visible += n;
        cat.style.display = n ? '' : 'none';
        if (n) {
          // Un groupe re-affiché par un filtre ne doit pas rester masqué par
          // l'animation de reveal au scroll.
          cat.classList.add('is-visible');
        }
        var tab = tabFor(cat.getAttribute('data-category'));
        if (tab) {
          tab.hidden = !n;
          var badge = tab.querySelector('[data-tab-count]');
          if (badge) { badge.textContent = complet ? String(n) : ''; }
        }
      });

      if (countEl) {
        countEl.textContent = visible + ' référence' + (visible > 1 ? 's' : '') + ' disponible' + (visible > 1 ? 's' : '');
      }
      if (emptyMsg) {
        emptyMsg.hidden = visible > 0;
      }
      spy();
      return visible;
    }

    // Réutilisée au remplacement du catalogue : l'état de filtre survit, les
    // nouveaux groupes le respectent immédiatement.
    scope.__redeskApplyFilters = function () {
      return applyFilters();
    };

    // Bas de la barre collante UNE FOIS COLLÉE (header + barre), et non sa
    // position courante : avant le premier défilement, elle est encore dans le
    // flux, plus bas. Sous 1080 px c'est la rangée d'onglets qui colle, pas la
    // barre entière : on mesure celui des deux qui est réellement collant.
    function stuckBottom() {
      // (une barre en display: contents garde position: sticky au calcul, mais
      // n'a plus de boîte : c'est sa hauteur nulle qui la trahit.)
      var el = nav && nav.offsetHeight > 0 ? nav : tabs;
      if (!el) { return 0; }
      return (parseFloat(window.getComputedStyle(el).top) || 0) + el.offsetHeight;
    }

    function jumpTo(fam) {
      var cats = scope.querySelectorAll('.redesk-pro-list__cat');
      var cat = null;
      for (var i = 0; i < cats.length; i++) {
        if (cats[i].getAttribute('data-category') === fam) { cat = cats[i]; break; }
      }
      if (!cat) { return; }
      cat.classList.add('is-visible');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var y = cat.getBoundingClientRect().top + window.pageYOffset - stuckBottom() - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      // Le focus suit la vue : au clavier, Tab repart de la famille atteinte
      // et non de l'onglet, 600 lignes plus haut.
      var hdr = cat.querySelector('.redesk-pro-list__cathdr');
      if (hdr) {
        hdr.setAttribute('tabindex', '-1');
        try { hdr.focus({ preventScroll: true }); } catch (error) { hdr.focus(); }
      }
    }

    // Onglet courant = dernière famille visible dont le haut est passé sous la
    // barre collante. Recalculé à la frame, pas à chaque événement scroll.
    var spyQueued = false;
    function spy() {
      spyQueued = false;
      if (!tabs) { return; }
      var limite = stuckBottom() + 16;
      var courant = null;
      scope.querySelectorAll('.redesk-pro-list__cat').forEach(function (cat) {
        if (cat.style.display !== 'none' && cat.getBoundingClientRect().top <= limite) {
          courant = cat.getAttribute('data-category');
        }
      });
      tabs.querySelectorAll('[data-cat-jump]').forEach(function (tab) {
        var actif = tab.getAttribute('data-cat-jump') === courant;
        if (actif === (tab.getAttribute('aria-current') === 'true')) { return; }
        if (actif) {
          tab.setAttribute('aria-current', 'true');
          // Sur mobile la rangée défile : l'onglet courant doit y rester visible.
          var r = tab.getBoundingClientRect();
          var box = tabs.getBoundingClientRect();
          if (r.left < box.left || r.right > box.right) {
            tabs.scrollLeft += r.left - box.left - 16;
          }
        } else {
          tab.removeAttribute('aria-current');
        }
      });
    }
    window.addEventListener('scroll', function () {
      if (!spyQueued) {
        spyQueued = true;
        window.requestAnimationFrame(spy);
      }
    }, { passive: true });

    if (tabs) {
      tabs.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-cat-jump]');
        if (!tab) {
          return;
        }
        var fam = tab.getAttribute('data-cat-jump');
        track('pro_filter', { type: 'famille', valeur: fam });
        jumpTo(fam);
      });
    }

    // Filtre appliqué à la frappe, mesuré une fois la saisie posée : taper
    // « 12 » ne doit pas émettre « 1 » puis « 12 ».
    var qtyTimer = null;
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        var n = parseInt(qtyInput.value, 10);
        state.minQty = n > 0 ? n : 0;
        var resultats = applyFilters();
        window.clearTimeout(qtyTimer);
        qtyTimer = window.setTimeout(function () {
          track('pro_filter', { type: 'quantite_min', valeur: state.minQty, nb_resultats: resultats });
        }, 800);
      });
    }

    // Filtre à la frappe, mesure une fois la saisie posée : « bureau 160 »
    // tapé lettre à lettre ne doit émettre qu'un pro_search, pas dix. C'est la
    // demande exprimée des acheteurs, qu'aucun événement ne captait.
    var searchTimer = null;
    var dernierTerme = '';
    function syncSearch() {
      var brut = searchInput.value.trim();
      state.terms = searchTerms(brut);
      if (clearBtn) { clearBtn.hidden = searchInput.value === ''; }
      var resultats = applyFilters();
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(function () {
        if (brut && brut !== dernierTerme) {
          dernierTerme = brut;
          track('pro_search', { terme: brut, nb_resultats: resultats });
        }
      }, 800);
    }
    if (searchInput) {
      searchInput.addEventListener('input', syncSearch);
    }
    // Bouton d'effacement visible : la seule croix native de type="search" est
    // discrète, absente de certains navigateurs, et un rage click a été
    // observé sur le champ (audit du 24/09/2026).
    if (clearBtn && searchInput) {
      clearBtn.addEventListener('click', function () {
        searchInput.value = '';
        syncSearch();
        searchInput.focus();
      });
    }

    // Sortie de l'état vide : un seul geste remet tout à zéro.
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        state.minQty = 0;
        state.terms = [];
        if (qtyInput) { qtyInput.value = ''; }
        if (searchInput) {
          searchInput.value = '';
          searchInput.focus();
        }
        if (clearBtn) { clearBtn.hidden = true; }
        applyFilters();
      });
    }

    applyFilters();
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  /* ponytail: on ne valide pas un plan de numérotation, on écarte seulement ce
     qui ne peut pas être un numéro : caractères autorisés + 9 à 15 chiffres
     (borne haute E.164). Un faux négatif coûte un lead, on reste permissif. */
  var PHONE_CHARS_RE = /^\+?[\d\s.\-()]+$/;

  function isPlausiblePhone(value) {
    var raw = String(value || '').trim();
    if (!PHONE_CHARS_RE.test(raw)) {
      return false;
    }
    var digits = raw.replace(/\D/g, '').length;
    return digits >= 9 && digits <= 15;
  }

  function initQuoteSheet(section) {
    var sheet = section.querySelector('[data-quote-sheet]');
    if (!sheet) {
      return;
    }

    var form = sheet.querySelector('[data-quote-form]');
    var summary = sheet.querySelector('[data-quote-summary]');
    var msg = sheet.querySelector('[data-quote-msg]');
    var submitBtn = sheet.querySelector('[data-quote-submit]');
    // querySelectorAll : la feuille a deux fermetures, la croix en haut et
    // « Retour » en bas. Au singulier, seule la première aurait été câblée.
    var closeBtns = sheet.querySelectorAll('[data-quote-close]');
    var webhook = section.getAttribute('data-quote-webhook');
    var openBtns = section.querySelectorAll('[data-quote-open]');

    function showMsg(text, kind) {
      if (!msg) {
        return;
      }
      msg.textContent = text;
      msg.className = 'redesk-pro-list__sheet-msg redesk-pro-list__sheet-msg--' + kind;
      msg.hidden = false;
    }

    function hideMsg() {
      if (!msg) {
        return;
      }
      msg.hidden = true;
      msg.textContent = '';
    }

    function fillSummary() {
      var detail = renderRecap();
      if (summary) {
        var keys = Object.keys(detail.list);
        // Le détail ligne à ligne, pas seulement l'agrégat : personne n'envoie
        // une demande à 4 000 € sans relire ce qu'il demande (QA 2026-07-28).
        var lines = keys.map(function (key) {
          var item = detail.list[key];
          return '<li class="redesk-pro-list__sheet-line">' +
            '<span class="redesk-pro-list__mono">' + item.qty + ' &times;</span> ' +
            escapeHtml(item.title) +
            '<span class="redesk-pro-list__sheet-line-price redesk-pro-list__mono">' +
              formatCents(item.qty * item.priceHt) + ' HT</span>' +
          '</li>';
        }).join('');

        summary.innerHTML =
          (lines ? '<ul class="redesk-pro-list__sheet-lines">' + lines + '</ul>' : '') +
          '<p class="redesk-pro-list__sheet-tot">' +
            '<span class="redesk-pro-list__mono">' + detail.totalQty + ' article' + (detail.totalQty > 1 ? 's' : '') + '</span>' +
            ' &middot; ' + keys.length + ' référence' + (keys.length > 1 ? 's' : '') +
            ' &middot; Total HT indicatif <span class="redesk-pro-list__mono">' + formatCents(detail.totalHt) + '</span>' +
          '</p>';
      }
      return detail;
    }

    // Ce qui a été donné à la capture progressive ne doit pas être redemandé.
    function prefillFromLead() {
      var lead = readLead();
      if (!lead || lead.dismissed || !form) {
        return;
      }
      ['societe', 'telephone'].forEach(function (name) {
        var field = form.querySelector('[name="' + name + '"]');
        if (field && !field.value.trim() && lead[name]) {
          field.value = lead[name];
        }
      });
    }

    var lastQuoteFocus = null;
    var previousBodyOverflow = '';

    // Le champ piège name="website" est en tabindex="-1" : l'exclure ici est ce
    // qui l'empêche de revenir dans la boucle du piège de focus. Le déplacer ou
    // le rendre focusable casserait l'anti-robot, on ne touche qu'au sélecteur.
    var SHEET_FOCUSABLES = 'button, [href], input:not([tabindex="-1"]), textarea, select';

    function sheetFocusables() {
      var card = sheet.querySelector('.redesk-pro-list__sheet-card') || sheet;
      return Array.prototype.filter.call(
        card.querySelectorAll(SHEET_FOCUSABLES),
        function (el) { return !el.disabled; }
      );
    }

    // Sans piège, la tabulation sort du formulaire et continue dans le pied de
    // page et le widget de chat, tous deux sous le voile et invisibles : on ne
    // voit plus où l'on est, et il faut retraverser la page pour revenir.
    function trapFocus(event) {
      if (event.key !== 'Tab') {
        return;
      }
      var items = sheetFocusables();
      if (!items.length) {
        return;
      }
      var premier = items[0];
      var dernier = items[items.length - 1];
      if (event.shiftKey && document.activeElement === premier) {
        event.preventDefault();
        dernier.focus();
      } else if (!event.shiftKey && document.activeElement === dernier) {
        event.preventDefault();
        premier.focus();
      }
    }

    sheet.addEventListener('keydown', trapFocus);

    function openSheet() {
      lastQuoteFocus = document.activeElement;
      var etat = listTotals();
      track('pro_quote_open', { nb_articles: etat.totalQty, total_ht: etat.totalHt });
      if (form) {
        form.hidden = false;
      }
      if (summary) {
        summary.hidden = false;
      }
      fillSummary();
      prefillFromLead();
      hideMsg();
      sheet.hidden = false;
      sheet.classList.add('is-open');
      // Sans verrou, la molette fait défiler la page derrière le voile : on
      // perd le formulaire de vue sans avoir rien fermé.
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      var firstEmpty = form && (form.querySelector('input:placeholder-shown') || form.querySelector('input'));
      if (firstEmpty && firstEmpty.focus) {
        firstEmpty.focus();
      }
    }

    function closeSheet() {
      sheet.classList.remove('is-open');
      sheet.hidden = true;
      // Restaurer la valeur d'origine, pas '' : le panneau récap peut avoir
      // posé son propre verrou, l'écraser débloquerait son défilement.
      document.body.style.overflow = previousBodyOverflow;
      if (lastQuoteFocus && lastQuoteFocus.focus) {
        lastQuoteFocus.focus();
      }
    }

    // Échap ferme, et le focus revient au déclencheur (constat QA 2026-07-28).
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !sheet.hidden) {
        closeSheet();
      }
    });

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) {
          return;
        }
        openSheet();
      });
    });

    if (closeBtns.length) {
      closeBtns.forEach(function (btn) { btn.addEventListener('click', closeSheet); });
    }

    sheet.addEventListener('click', function (event) {
      if (event.target === sheet) {
        closeSheet();
      }
    });

    function setFieldValidity(field, isValid) {
      var wrapper = field.closest('.redesk-pro-list__field');
      if (wrapper) {
        wrapper.classList.toggle('is-invalid', !isValid);
      }
    }

    // Renvoie '' si le formulaire est valide, sinon le message à afficher.
    // Un message générique ("complétez les champs obligatoires") sur un champ
    // rempli mais mal formaté envoie l'utilisateur chercher un champ vide qui
    // n'existe pas (QA 2026-07-28).
    function validateForm() {
      if (!form) {
        return 'Formulaire indisponible.';
      }
      var societe = form.querySelector('[name="societe"]');
      var nom = form.querySelector('[name="nom"]');
      var telephone = form.querySelector('[name="telephone"]');
      var email = form.querySelector('[name="email"]');
      var missing = false;

      [societe, nom, telephone].forEach(function (field) {
        var ok = !!(field && field.value.trim());
        setFieldValidity(field, ok);
        if (!ok) {
          missing = true;
        }
      });

      var emailFilled = !!(email && email.value.trim());
      var emailOk = emailFilled && EMAIL_RE.test(email.value.trim());
      setFieldValidity(email, emailOk);
      if (!emailFilled) {
        missing = true;
      }

      // Le rappel téléphonique EST la promesse du parcours : un numéro
      // injoignable rend le lead inutile.
      var phoneFilled = !!(telephone && telephone.value.trim());
      var phoneOk = phoneFilled && isPlausiblePhone(telephone.value);
      if (phoneFilled) {
        setFieldValidity(telephone, phoneOk);
      }

      if (missing) {
        return 'Merci de compléter les champs obligatoires (*).';
      }
      if (!phoneOk) {
        return 'Ce numéro de téléphone ne semble pas valide. Un conseiller doit pouvoir vous rappeler.';
      }
      if (!emailOk) {
        return 'Cette adresse email ne semble pas valide (exemple : prenom@societe.fr).';
      }
      return '';
    }

    // Un champ corrigé doit cesser d'être signalé sans attendre la soumission
    // suivante (QA 2026-07-28).
    if (form) {
      form.addEventListener('input', function (event) {
        var field = event.target;
        if (!field || !field.name) {
          return;
        }
        var wrapper = field.closest ? field.closest('.redesk-pro-list__field') : null;
        if (wrapper && wrapper.classList.contains('is-invalid') && field.value.trim()) {
          wrapper.classList.remove('is-invalid');
        }
        hideMsg();
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        hideMsg();

        var problem = validateForm();
        if (problem) {
          showMsg(problem, 'err');
          return;
        }

        // Garde-fou webhook non renseigné : ce n'est pas une erreur de
        // l'utilisateur, donc pas le style d'erreur (QA 2026-07-28).
        if (!webhook) {
          showMsg('Envoi indisponible pour le moment. Appelez-nous ou réessayez plus tard.', 'info');
          return;
        }

        var list = readList();
        var keys = Object.keys(list);
        var lignes = keys.map(function (key) {
          return {
            variantId: key,
            title: list[key].title,
            qty: list[key].qty,
            priceHt: list[key].priceHt
          };
        });
        var totalHt = keys.reduce(function (sum, key) {
          return sum + (list[key].qty * list[key].priceHt);
        }, 0);

        // Identifiant de demande : le bouton est réactivé en cas d'erreur réseau,
        // donc un même envoi peut partir deux fois. Le flow s'en sert comme clé
        // d'idempotence (tag du draft order) pour ne pas créer de doublon.
        var demandeId = 'pro-' + Date.now().toString(36) + '-' +
          Math.random().toString(36).slice(2, 8);

        // Champ piège anti-bot : rempli, c'est un robot. On envoie la valeur
        // telle quelle, c'est le flow n8n qui arbitre (garde côté serveur).
        var piege = form.querySelector('[name="website"]');

        var payload = {
          demande_id: demandeId,
          type: 'devis',
          website: piege ? piege.value : '',
          contact: {
            societe: form.querySelector('[name="societe"]').value.trim(),
            siret: form.querySelector('[name="siret"]').value.trim(),
            nom: form.querySelector('[name="nom"]').value.trim(),
            telephone: form.querySelector('[name="telephone"]').value.trim(),
            email: form.querySelector('[name="email"]').value.trim(),
            message: form.querySelector('[name="message"]').value.trim()
          },
          lignes: lignes,
          total_ht: totalHt,
          page_url: window.location.href,
          attribution: attributionDevis()
        };

        if (submitBtn) {
          submitBtn.disabled = true;
        }

        fetch(webhook, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error(String(response.status));
            }
            return response;
          })
          .then(function () {
            track('pro_quote_submit', {
              demande_id: demandeId,
              nb_lignes: lignes.length,
              nb_articles: lignes.reduce(function (n, l) { return n + l.qty; }, 0),
              total_ht: totalHt
            });
            // Conversion GA4/Ads (schéma docs/agents/datalayer-schema.md). Le
            // formulaire pro n'a pas de case de consentement : consent false,
            // donc aucune donnée personnelle ne part dans le dataLayer.
            if (window.RedeskDL && typeof window.RedeskDL.pushFormSubmit === 'function') {
              window.RedeskDL.pushFormSubmit({ form_id: 'pro_quote', intent: 'devis', consent: false });
            }
            // Le lien est construit AVANT le vidage : la liste envoyée reste
            // réouvrable (le même récap part aussi dans le mail de réception).
            var listUrl = buildListUrl();
            try {
              window.localStorage.removeItem(STORAGE_KEY);
            } catch (error) {
              /* localStorage indisponible : on ignore. */
            }
            renderRecap();
            form.reset();
            form.hidden = true;
            if (summary) {
              summary.hidden = true;
            }
            showMsg(
              'Votre demande est bien envoyée, un conseiller vous rappelle. Gardez le lien de votre liste : ' + listUrl,
              'ok'
            );
          })
          .catch(function (error) {
            track('pro_quote_error', {
              demande_id: demandeId,
              raison: (error && error.message) || 'inconnue',
              total_ht: totalHt
            });
            showMsg('Oups, une erreur est survenue. Réessayez dans un instant.', 'err');
          })
          .then(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
            }
          });
      });
    }
  }

  /* ---------- Catalogue AJAX ---------- */

  function fmtPriceCents(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return value.replace(/\B(?=(\d{3})+(?!\d),)/g, ' ') + ' €';
  }

  var PRODUCTS_PER_PAGE = 250;

  // Un lot de pages parti d'un coup peut se faire limiter (429 observé sur la
  // prod en enchaînant les chargements). Comme une seule page en échec fait
  // tomber tout le catalogue, on réessaie une fois après une courte pause.
  function fetchProductPage(handle, p, retry) {
    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + PRODUCTS_PER_PAGE + '&page=' + p;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) { throw new Error('HTTP ' + r.status); }
        return r.json();
      })
      .then(function (data) { return (data && data.products) || []; })
      .catch(function (error) {
        if (retry) { throw error; }
        return new Promise(function (resolve) { setTimeout(resolve, 600); })
          .then(function () { return fetchProductPage(handle, p, true); });
      });
  }

  // Un produit dont aucune variante n'est disponible n'est jamais rendu
  // (buildRow() retourne ''), il n'alimente ni la recherche ni les filtres.
  // Mesuré le 15/09/2026 : 1 425 produits servis, 481 proposables. Écarter les
  // 944 autres dès la réception évite de les garder en mémoire et de les
  // reparcourir à chaque rendu.
  function isOfferable(product) {
    var variants = (product && product.variants) || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) { return true; }
    }
    return false;
  }

  // Mémoire du nombre de pages réellement servi, par collection. Le compteur
  // Liquid sous-évalue durablement (612 vus par Liquid contre 1 425 servis par
  // products.json), donc la première visite paie une reprise ; les suivantes
  // partent du bon nombre. sessionStorage : un catalogue qui grossit pendant la
  // session reste couvert par le filet de reprise, et rien ne survit à la
  // fermeture de l'onglet.
  var PAGES_KEY = 'redesk_pro_pages_';

  function rememberedPages(handle) {
    try {
      var value = parseInt(window.sessionStorage.getItem(PAGES_KEY + handle), 10);
      return value > 0 ? value : 0;
    } catch (error) { return 0; }
  }

  function rememberPages(handle, pages) {
    try { window.sessionStorage.setItem(PAGES_KEY + handle, String(pages)); } catch (error) { /* mode privé */ }
  }

  // Charge TOUS les produits de la collection via l'endpoint public products.json
  // (paginé, sans token). Contourne la limite Liquid de 50 produits par page.
  //
  // Le nombre de pages de départ vient du plus grand de deux paris : le
  // compteur Liquid (data-product-count) et le nombre de pages observé lors
  // d'un chargement précédent dans la même session. Les pages partent d'un coup
  // au lieu d'attendre la page N pour savoir s'il faut la N+1.
  //
  // Ce nombre n'est qu'un PLANCHER, jamais une vérité : Liquid ne voit pas le
  // même périmètre que products.json (612 contre 1 425 le 15/09/2026, issue
  // #70). Le filet de reprise est donc conservé, mais il reprend par LOTS
  // parallèles de la même taille au lieu d'une page à la fois : sur 6 pages
  // annoncées 3, c'est un aller-retour de rattrapage au lieu de trois.
  // Aucun produit perdu, on s'arrête sur la première page incomplète.
  function fetchAllProducts(handle, knownCount) {
    var fromCount = knownCount > 0 ? Math.ceil(knownCount / PRODUCTS_PER_PAGE) : 1;
    var pages = Math.max(fromCount, rememberedPages(handle), 1);
    var all = [];
    var served = 0;

    // Récupère les pages [from, to] en parallèle, puis rappelle le lot suivant
    // tant que la dernière page revient pleine.
    function batch(from, to) {
      var wanted = [];
      for (var p = from; p <= to; p += 1) { wanted.push(p); }

      return Promise.all(wanted.map(function (p) { return fetchProductPage(handle, p); }))
        .then(function (lists) {
          var last = [];
          for (var i = 0; i < lists.length; i++) {
            var list = lists[i];
            if (list.length) { served = from + i; }
            for (var j = 0; j < list.length; j++) {
              if (isOfferable(list[j])) { all.push(list[j]); }
            }
            last = list;
          }
          if (last.length === PRODUCTS_PER_PAGE) {
            return batch(to + 1, to + (to - from + 1));
          }
          rememberPages(handle, served || 1);
          return all;
        });
    }

    return batch(1, pages);
  }

  // Stock réel par variante via la vue Liquid collection.pro-inventory
  // (les endpoints publics products.json n'exposent pas inventory_quantity).
  // Optionnel : en cas d'échec on retombe sur MAX_QTY_FALLBACK, le catalogue
  // reste utilisable.
  //
  // La page 1 renvoie data.pages : les pages suivantes partent donc toutes en
  // parallèle (~1,6s au lieu de ~4s sur 5 pages).
  function fetchInventory(handle) {
    var inv = {};

    function page(p) {
      var url = '/collections/' + encodeURIComponent(handle) + '?view=pro-inventory&page=' + p;
      return fetch(url)
        .then(function (r) {
          if (!r.ok) { throw new Error('HTTP ' + r.status); }
          return r.text();
        })
        .then(function (text) {
          var data = JSON.parse(text);
          Object.keys(data.inv || {}).forEach(function (key) {
            inv[key] = data.inv[key];
          });
          return data.pages || 1;
        });
    }

    return page(1)
      .then(function (pages) {
        var rest = [];
        for (var p = 2; p <= pages; p += 1) { rest.push(page(p)); }
        return Promise.all(rest);
      })
      .then(function () { return inv; })
      .catch(function () { return inv; });
  }

  /* L'état vit sur l'OPTION DE VARIANTE « Etat », pas dans les tags.

     Cette fonction lisait auparavant une liste de tags ('comme neuf', 'très bon
     état', ...) : relevé du 18/09/2026 sur products.json, 0 produit sur 250 en
     portait un, quand 248 sur 250 avaient l'option de variante. Le catalogue
     n'affichait donc jamais l'état, et un acheteur a fini par le demander par
     écrit. L'information existait, elle n'était pas montrée.

     On cherche l'option par son NOM, accents et casse ignorés, et non par une
     position fixe : l'ordre des options n'est pas garanti d'un produit à
     l'autre. */
  function etatFromVariant(product, variant) {
    if (!product || !variant) { return ''; }
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      var nom = normalizeText(typeof option === 'string' ? option : (option && option.name));
      if (nom === 'etat') {
        var position = (option && option.position) ? option.position : (i + 1);
        return String(variant['option' + position] || '').trim();
      }
    }
    return '';
  }

  function buildRow(product, vatRate, invMap) {
    var variants = product.variants || [];
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) { variant = variants[i]; break; }
    }
    if (!variant) { return ''; }

    // Les prix Shopify du catalogue sont HT (cf. snippets/price.liquid) :
    // on les reprend tels quels, le TTC affiché est indicatif (HT x taux).
    var htCents = Math.round(parseFloat(variant.price) * 100);
    if (!htCents || htCents <= 0) { return ''; }
    var ttcCents = Math.round(htCents * vatRate);

    var stock = invMap ? invMap[String(variant.id)] : null;
    var max = (typeof stock === 'number' && stock > 0) ? stock : MAX_QTY_FALLBACK;

    var img = (product.images && product.images[0]) ? product.images[0].src : '';
    var imgTag = img
      ? '<img src="' + escapeHtml(img) + (img.indexOf('?') === -1 ? '?width=120' : '&width=120') +
        '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="60" height="60">'
      : '';
    var etat = etatFromVariant(product, variant);
    var dispo = (typeof stock === 'number' && stock > 0)
      ? stock + ' disponible' + (stock > 1 ? 's' : '')
      : 'Disponible';
    var meta = dispo + (etat ? ' · ' + escapeHtml(etat) : '');

    return (
      '<div class="redesk-pro-list__row" data-variant-id="' + escapeHtml(variant.id) + '"' +
        ' data-handle="' + escapeHtml(product.handle) + '"' +
        ' data-title="' + escapeHtml(product.title) + '"' +
        ' data-max="' + max + '"' +
        ' data-etat="' + escapeHtml(etat) + '"' +
        ' data-sku="' + escapeHtml(variant.sku || '') + '"' +
        ' data-price-ht="' + htCents + '" data-price-ttc="' + ttcCents + '">' +
        '<div class="redesk-pro-list__thumb" data-peek-toggle>' + imgTag + '</div>' +
        '<div class="redesk-pro-list__info">' +
          '<button type="button" class="redesk-pro-list__name" data-peek-toggle aria-expanded="false" title="' + escapeHtml(product.title) + '"><span class="redesk-pro-list__name-txt">' + escapeHtml(product.title) + '</span></button>' +
          '<div class="redesk-pro-list__meta"><span class="redesk-pro-list__dot"></span>' + meta + '</div>' +
          '<span class="redesk-pro-list__inlist" data-inlist hidden></span>' +
          '<p class="redesk-pro-list__clamp" data-clamp-notice role="status" aria-live="polite" hidden></p>' +
        '</div>' +
        '<div class="redesk-pro-list__price">' +
          '<div class="redesk-pro-list__price-ht">' + fmtPriceCents(htCents) + '<small> HT</small></div>' +
          '<div class="redesk-pro-list__price-ttc">' + fmtPriceCents(ttcCents) + ' TTC</div>' +
        '</div>' +
        '<div class="redesk-pro-list__add">' +
          '<div class="redesk-pro-list__stepper" data-stepper>' +
            '<button type="button" class="redesk-pro-list__step-btn" data-step="minus" aria-label="Diminuer la quantité">&minus;</button>' +
            '<input type="text" class="redesk-pro-list__step-input" value="1" inputmode="numeric" data-qty aria-label="Quantité">' +
            '<button type="button" class="redesk-pro-list__step-btn" data-step="plus" aria-label="Augmenter la quantité">+</button>' +
          '</div>' +
          '<button type="button" class="redesk-pro-list__add-btn" data-add>Ajouter</button>' +
        '</div>' +
      '</div>'
    );
  }

  // Segments non vides et non ".." du product_type ("..//bureaux//bureaux_droits//.."
  // -> ["bureaux", "bureaux_droits"]).
  function typeSegments(type) {
    var raw = String(type || '').split('/');
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      if (raw[i] && raw[i] !== '..') { out.push(raw[i].toLowerCase()); }
    }
    return out;
  }

  /* Segments dont le libellé ne se déduit pas du product_type : celui-ci est
     stocké sans accents dans Shopify (« espaces_detente »), et le dérouler
     mécaniquement donnait « Espaces detente » au milieu d'un filtre dont toutes
     les autres entrées sont accentuées (issue #59).

     PARITÉ OBLIGATOIRE avec snippets/redesk-pro-famille.liquid : ce libellé sert
     aussi de valeur à data-category et à data-cat-jump, donc une divergence
     entre les deux ne ferait pas qu'enlaidir, elle casserait le filtrage. */
  var SEG_LABELS = {
    espaces_detente: 'Espaces détente'
  };

  function cleanSeg(seg) {
    if (!seg) { return 'Autres'; }
    if (SEG_LABELS[seg]) { return SEG_LABELS[seg]; }
    var s = seg.replace(/_/g, ' ');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // Groupe d'affichage : famille (1er segment) affinee sur quelques sous-types
  // demandes. Bureaux : benchs (multipostes) separes des bureaux. Assises :
  // fauteuils de bureau et chaises de reunion separes, le reste regroupe.
  function groupLabel(type) {
    var segs = typeSegments(type);
    var top = segs[0] || '';
    var sub = segs[1] || '';
    if (top === 'bureaux') {
      if (sub.indexOf('multiposte') !== -1 || sub.indexOf('bench') !== -1) { return 'Benchs'; }
      return 'Bureaux';
    }
    if (top === 'assises') {
      if (sub.indexOf('fauteuil') !== -1 && sub.indexOf('bureau') !== -1) { return 'Fauteuils de bureau'; }
      if (sub.indexOf('reunion') !== -1) { return 'Chaises de réunion'; }
      return 'Assises';
    }
    return cleanSeg(top);
  }

  // Rang d'affichage : mobilier de travail d'abord, accessoires en dernier.
  // Les groupes inconnus tombent au milieu (rang 50), tries alpha.
  var FAM_ORDER = ['Bureaux', 'Benchs', 'Fauteuils de bureau', 'Chaises de réunion', 'Assises', 'Tables', 'Rangements', 'Mobilier acoustique', 'Cloisons'];
  function famRank(fam) {
    var i = FAM_ORDER.indexOf(fam);
    if (i !== -1) { return i; }
    if (fam === 'Accessoires' || fam === 'Autres') { return 100; }
    return 50;
  }

  function renderCatalog(section, products, vatRate, invMap) {
    var catalog = section.querySelector('[data-catalog]');
    var filterList = section.querySelector('[data-filter-list]');
    var countEl = section.querySelector('[data-count]');
    var status = section.querySelector('[data-catalog-status]');
    if (!catalog) { return; }

    // Groupe par famille, dans l'ordre de première apparition.
    var order = [];
    var groups = {};
    var shown = 0;
    products.forEach(function (product) {
      var rowHtml = buildRow(product, vatRate, invMap);
      if (!rowHtml) { return; }
      productsByHandle[product.handle] = product;
      var fam = groupLabel(product.product_type);
      if (!groups[fam]) { groups[fam] = []; order.push(fam); }
      groups[fam].push(rowHtml);
      shown++;
    });

    // Ordre editorial : le mobilier serieux d'abord, les accessoires en dernier.
    order.sort(function (a, b) {
      var ra = famRank(a);
      var rb = famRank(b);
      if (ra !== rb) { return ra - rb; }
      return a.localeCompare(b, 'fr');
    });

    if (shown === 0) {
      if (status) { status.textContent = 'Aucune référence disponible pour le moment.'; }
      return;
    }

    // Question d'aide par famille, même table que le rendu serveur (réglage fam_help).
    var famHelp = {};
    try { famHelp = JSON.parse(section.querySelector('[data-fam-help]').textContent); } catch (error) { /* pas d'aide */ }

    var catalogHtml = order.map(function (fam) {
      return (
        '<section class="redesk-pro-list__cat" data-category="' + escapeHtml(fam) + '">' +
          '<div class="redesk-pro-list__cathdr">' + escapeHtml(fam) + '</div>' +
          (famHelp[fam] && famHelp[fam].q
            ? '<details class="redesk-pro-list__cathelp" data-fam-help-q="' + escapeHtml(fam) + '"><summary>' +
              escapeHtml(famHelp[fam].q) + '</summary><p>' + escapeHtml(famHelp[fam].a) + '</p></details>'
            : '') +
          groups[fam].join('') +
        '</section>'
      );
    }).join('');
    catalog.innerHTML = catalogHtml;

    if (filterList) {
      // Les onglets du premier écran server-rendered ne couvrent que les
      // premières références : on les REMPLACE. Markup identique à celui de
      // la section (PARITÉ), les compteurs sont écrits par applyFilters().
      filterList.innerHTML = order.map(function (fam) {
        return '<button type="button" class="redesk-pro-list__tab" data-cat-jump="' +
          escapeHtml(fam) + '">' + escapeHtml(fam) + '<span class="redesk-pro-list__tab-n" data-tab-count></span></button>';
      }).join('');
    }

    if (countEl) {
      countEl.textContent = shown + ' référence' + (shown > 1 ? 's' : '') + ' disponible' + (shown > 1 ? 's' : '');
    }

  }

  /* ---------- Aperçu léger (issue #103) ----------
     Clic sur le nom ou la vignette : la ligne se déplie sans quitter l'outil
     ni perdre la liste. Photos, prix, état et stock sont déjà en mémoire
     (products.json, data-* de la ligne). Seuls les dimensions et la date de
     disponibilité demandent un appel, à la section redesk-pro-peek, UNE fois
     par produit : la promesse est gardée par handle, un second dépliage (même
     après remplacement du catalogue) ne refait pas de requête. */
  var productsByHandle = {};
  var peekCache = {};

  function peekUrl(handle) {
    return '/products/' + encodeURIComponent(handle) + '?section_id=redesk-pro-peek';
  }

  function fetchPeek(handle) {
    if (!peekCache[handle]) {
      peekCache[handle] = fetch(peekUrl(handle))
        .then(function (r) {
          if (!r.ok) { throw new Error('HTTP ' + r.status); }
          return r.text();
        })
        .catch(function (error) {
          // Un échec ne reste pas en cache : le dépliage suivant réessaie.
          delete peekCache[handle];
          throw error;
        });
    }
    return peekCache[handle];
  }

  // Grade lettré = suffixe du SKU (_B, _C, _D), répliqué dans l'option « Etat ».
  function gradeFromSku(sku) {
    var m = /_([A-D])$/i.exec(String(sku || ''));
    return m ? m[1].toUpperCase() : '';
  }

  function withWidth(src, width) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function buildPeek(row, panelId) {
    var handle = row.getAttribute('data-handle') || '';
    var title = row.getAttribute('data-title') || '';
    var product = productsByHandle[handle];
    var images = product && product.images && product.images.length
      ? product.images.slice(0, 4).map(function (img) { return img.src; })
      : [];
    // Premier écran rendu côté serveur, catalogue pas encore arrivé : on
    // montre au moins la vignette de la ligne.
    if (!images.length) {
      var thumb = row.querySelector('.redesk-pro-list__thumb img');
      if (thumb) { images = [thumb.getAttribute('src').replace(/[?&]width=\d+/, '')]; }
    }
    var photos = images.map(function (src, i) {
      return '<img src="' + escapeHtml(withWidth(src, 360)) + '" alt="' + escapeHtml(title) + ' : photo ' + (i + 1) +
        '" loading="lazy" width="120" height="120">';
    }).join('');

    var etat = row.getAttribute('data-etat') || '';
    var grade = gradeFromSku(row.getAttribute('data-sku'));
    var etatTexte = etat && grade ? etat + ' · grade ' + grade : (etat || (grade ? 'Grade ' + grade : ''));
    var max = parseInt(row.getAttribute('data-max'), 10) || 0;
    var dispo = max > 0 && max < MAX_QTY_FALLBACK
      ? max + ' disponible' + (max > 1 ? 's' : '')
      : 'Disponible';
    var prix = fmtPriceCents(parseInt(row.getAttribute('data-price-ht'), 10) || 0) + ' HT';

    return (
      '<div class="redesk-pro-list__peek" id="' + panelId + '" data-peek role="region" aria-label="' + escapeHtml('Aperçu : ' + title) + '">' +
        (photos ? '<div class="redesk-pro-list__peek-photos">' + photos + '</div>' : '') +
        '<div class="redesk-pro-list__peek-facts">' +
          '<dl class="redesk-pro-list__peek-dims redesk-pro-list__peek-meta">' +
            (etatTexte ? '<div><dt>État</dt><dd>' + escapeHtml(etatTexte) + '</dd></div>' : '') +
            '<div><dt>Prix</dt><dd>' + prix + '</dd></div>' +
            '<div><dt>Quantité</dt><dd>' + dispo + '</dd></div>' +
          '</dl>' +
          '<div class="redesk-pro-list__peek-slot" data-peek-slot><p class="redesk-pro-list__peek-none">Chargement des dimensions...</p></div>' +
          '<a class="redesk-pro-list__peek-link" href="/products/' + encodeURIComponent(handle) + '" target="_blank" rel="noopener" data-peek-link>Voir la fiche complète</a>' +
        '</div>' +
      '</div>'
    );
  }

  // Sur mobile, un aperçu déplié près du bas passerait sous la barre fixe :
  // on l'amène à l'écran (scroll-margin posé en CSS), seulement s'il en sort.
  function revealPeek(panel) {
    if (panel.scrollIntoView) {
      panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  function togglePeek(row) {
    var button = row.querySelector('button[data-peek-toggle]');
    var panel = row.querySelector('[data-peek]');
    var ouvrir = !panel || panel.hidden;
    if (!ouvrir) {
      panel.hidden = true;
      row.classList.remove('is-peek-open');
      if (button) { button.setAttribute('aria-expanded', 'false'); }
      return;
    }
    var handle = row.getAttribute('data-handle');
    if (!panel) {
      var panelId = 'ProPeek-' + row.getAttribute('data-variant-id');
      row.insertAdjacentHTML('beforeend', buildPeek(row, panelId));
      panel = row.querySelector('[data-peek]');
      if (button) { button.setAttribute('aria-controls', panelId); }
      var slot = panel.querySelector('[data-peek-slot]');
      if (handle && slot) {
        fetchPeek(handle)
          .then(function (html) {
            var tpl = document.createElement('template');
            tpl.innerHTML = html;
            var data = tpl.content.querySelector('[data-peek-data]');
            slot.innerHTML = '';
            if (data) { slot.appendChild(data); }
            revealPeek(panel);
          })
          .catch(function () {
            slot.innerHTML = '<p class="redesk-pro-list__peek-none">Dimensions indisponibles pour le moment : voir la fiche complète.</p>';
          });
      }
    }
    panel.hidden = false;
    row.classList.add('is-peek-open');
    if (button) { button.setAttribute('aria-expanded', 'true'); }
    revealPeek(panel);
    track('pro_peek_open', { handle: handle, variant_id: row.getAttribute('data-variant-id') });
  }

  // Écouteurs délégués sur la section : ils survivent au remplacement du
  // catalogue, qui recrée toutes les lignes.
  function initPeek(section) {
    section.addEventListener('click', function (event) {
      var link = event.target.closest('[data-peek-link]');
      if (link) {
        var linkRow = link.closest('.redesk-pro-list__row');
        track('pro_product_open', {
          handle: linkRow ? linkRow.getAttribute('data-handle') : '',
          variant_id: linkRow ? linkRow.getAttribute('data-variant-id') : '',
          source: 'apercu'
        });
        return;
      }
      var toggle = event.target.closest('[data-peek-toggle]');
      var row = toggle ? toggle.closest('.redesk-pro-list__row') : null;
      if (row) {
        togglePeek(row);
      }
    });
  }

  function initCatalog(section) {
    var wrap = section.querySelector('[data-collection]');
    if (!wrap) { return; }
    var handle = wrap.getAttribute('data-collection') || 'all';
    var vatRate = parseFloat(wrap.getAttribute('data-vat-rate')) || 1.2;
    var knownCount = parseInt(wrap.getAttribute('data-product-count'), 10) || 0;
    var status = section.querySelector('[data-catalog-status]');

    // Premier écran rendu côté serveur : il doit être utilisable tout de suite,
    // pas seulement joli. On câble donc les steppers, l'ajout et les filtres
    // avant même de lancer les requêtes.
    //
    // PAS de hydrateFromUrl() ici : elle retire `l` de l'URL après import, et le
    // premier écran ne contient qu'une partie des références. Une liste partagée
    // perdrait toutes les lignes absentes de ce premier écran.
    initSteppers(section);
    initAddButtons(section);
    initFilters(section);
    // Une liste déjà constituée doit se voir dès le premier écran, sans attendre
    // le catalogue complet : l'état est relu dans localStorage, pas reconstruit.
    syncRowStates(section);

    Promise.all([fetchAllProducts(handle, knownCount), fetchInventory(handle)])
      .then(function (results) {
        renderCatalog(section, results[0], vatRate, results[1]);
        section.setAttribute('data-catalog-complete', '');
        // Re-câblage APRÈS remplacement : les lignes du premier écran ont été
        // détruites, celles-ci n'ont encore aucun écouteur.
        initSteppers(section);
        initAddButtons(section);
        initFilters(section);
        // Les lignes du premier écran ont été détruites avec leur état peint :
        // sans ce rappel, tout ce qui est déjà en liste redeviendrait invisible
        // au moment précis où le catalogue complet arrive.
        syncRowStates(section);
        setupReveal(section);
        // Liste passée en ?l= : réhydratée ici, une fois TOUTES les lignes
        // disponibles.
        hydrateFromUrl(section);
      })
      .catch(function () {
        // Sans premier écran server-rendered, [data-catalog-status] existe et
        // porte le message. Avec, on garde les lignes servies et on signale que
        // le reste du catalogue manque : sinon le pro croit que 50 références
        // sont tout le stock.
        if (status) {
          status.textContent = 'Le catalogue est momentanément indisponible. Réessayez dans un instant.';
          return;
        }
        var catalog = section.querySelector('[data-catalog]');
        if (catalog && !catalog.querySelector('[data-catalog-partial]')) {
          catalog.insertAdjacentHTML('beforeend',
            '<p class="redesk-pro-list__empty" data-catalog-partial role="status">' +
            'Seules les premières références ont pu être chargées. Rechargez la page pour voir tout le catalogue.' +
            '</p>');
        }
      });
  }

  // Reveal au scroll des groupes de categorie. Ajoute .reveal-ready (le CSS ne
  // masque QUE dans ce cas), puis revele chaque groupe a l'entree dans le viewport.
  function setupReveal(section) {
    var catalog = section.querySelector('[data-catalog]');
    if (!catalog) { return; }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { return; }

    catalog.classList.add('reveal-ready');
    var cats = catalog.querySelectorAll('.redesk-pro-list__cat');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    cats.forEach(function (cat) { io.observe(cat); });
  }

  /* ---------- Capture progressive (ADR-0004, arbitrage du 15/09/2026) ----------
     On demande la société pour qu'une liste abandonnée reste rattrapable par un
     commercial. REFUSABLE par construction : « pas de compte à créer » est
     l'argument le plus fort de la page, un péage au premier clic le détruirait.
     Un refus est mémorisé, on ne redemande pas.

     Le déclencheur n'est plus le premier article (4,2 % de conversion mesurés
     sur les popups immédiats) mais un signal d'intention : le 3e article, ou
     l'exit-intent comme filet dès qu'il y a quelque chose à sauver. */

  var LEAD_KEY = 'redesk_pro_lead';
  /* Seuil compté en ARTICLES (listTotals().totalQty), pas en lignes : trois
     exemplaires d'un même siège est un aménagement réel, donc une liste qui
     vaut la peine d'être sauvée, autant que trois références différentes. */
  var LEAD_SEUIL_ARTICLES = 3;
  var leadSheet = null;
  var leadDejaOuverte = false;
  var exitIntentArme = false;

  /* Décision de déclenchement, pure et sans DOM : c'est la seule chose qui
     décide que la modale s'ouvre, et c'est elle que
     scripts/check-pro-lead-capture.mjs exécute sur des cas. */
  function leadTriggerReason(etat) {
    if (!etat || etat.dejaOuverte || etat.dejaRepondu) {
      return null;
    }
    if (etat.nbArticles >= LEAD_SEUIL_ARTICLES) {
      return 'articles';
    }
    if (etat.sortieParLeHaut && etat.nbArticles >= 1) {
      return 'exit_intent';
    }
    return null;
  }

  /* Seule une sortie par le HAUT de la fenêtre signale un départ (barre
     d'adresse, onglets). Par le bas ou les côtés, le curseur va vers une autre
     fenêtre ou la barre de défilement : ce n'est pas une intention de quitter. */
  function isExitIntentEvent(event) {
    return !!event && typeof event.clientY === 'number' && event.clientY <= 0;
  }

  /* L'exit-intent n'existe pas au doigt : mouseleave n'est jamais émis sur
     mobile. On n'y branche donc aucun écouteur, et surtout pas de piège au
     bouton retour. Sur mobile, seule la règle des articles s'applique. */
  function pointeurSurvolant() {
    try {
      return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    } catch (error) {
      return false;
    }
  }

  function maybeOpenLeadSheet(sortieParLeHaut) {
    if (!leadSheet) {
      return null;
    }
    var raison = leadTriggerReason({
      nbArticles: listTotals().totalQty,
      sortieParLeHaut: !!sortieParLeHaut,
      dejaOuverte: leadDejaOuverte,
      dejaRepondu: !!readLead()
    });
    if (!raison) {
      return null;
    }
    leadDejaOuverte = true;
    leadSheet.open(raison);
    return raison;
  }

  function onDocumentMouseLeave(event) {
    if (!isExitIntentEvent(event)) {
      return;
    }
    maybeOpenLeadSheet(true);
    syncExitIntent();
  }

  /* Écouteur branché seulement tant qu'il peut servir, et débranché dès qu'il
     ne sert plus (modale vue, informations données, refus mémorisé). */
  function syncExitIntent() {
    var utile = !!leadSheet &&
      !leadDejaOuverte &&
      !readLead() &&
      listTotals().totalQty >= 1 &&
      pointeurSurvolant();
    if (utile === exitIntentArme) {
      return;
    }
    if (utile) {
      document.addEventListener('mouseleave', onDocumentMouseLeave);
    } else {
      document.removeEventListener('mouseleave', onDocumentMouseLeave);
    }
    exitIntentArme = utile;
  }

  /* Validation de la feuille de lead, pure et exécutable hors navigateur.
     Le téléphone est OBLIGATOIRE depuis le 02/10/2026 : un lead « Mallow »
     sans numéro ni mail a prouvé qu'une société seule ne permet pas de
     rappeler qui que ce soit (exécution n8n #6726). */
  function leadChampsValides(societe, telephone) {
    var tel = String(telephone || '').trim();
    return {
      societeOk: String(societe || '').trim() !== '',
      telephoneOk: isPlausiblePhone(tel)
    };
  }

  /* Verdict honnête d'une soumission : seule une réponse 2xx vaut
     « enregistré ». Un échec réseau n'arrive même pas jusqu'ici. */
  function leadSubmitEnregistre(reponse) {
    return !!(reponse && reponse.ok);
  }

  function readLead() {
    try {
      var raw = window.localStorage.getItem(LEAD_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeLead(value) {
    try {
      window.localStorage.setItem(LEAD_KEY, JSON.stringify(value));
    } catch (error) {
      /* localStorage indisponible : la modale se réaffichera, sans casser. */
    }
  }

  function initLeadSheet(section) {
    var sheet = section.querySelector('[data-lead-sheet]');
    if (!sheet) {
      return null;
    }

    var form = sheet.querySelector('[data-lead-form]');
    var msg = sheet.querySelector('[data-lead-msg]');
    var submitBtn = sheet.querySelector('[data-lead-submit]');
    var webhook = section.getAttribute('data-quote-webhook');
    var lastFocus = null;
    var soumise = false;

    function close(reason) {
      var etaitOuverte = !sheet.hidden;
      sheet.classList.remove('is-open');
      sheet.hidden = true;
      if (reason === 'dismissed') {
        // Une fermeture après soumission n'est pas un refus : le pro a donné
        // ses informations, compter un dismiss fausserait le taux.
        if (etaitOuverte && !soumise) {
          track('pro_lead_capture_dismiss', { nb_articles: listTotals().totalQty });
        }
        if (!readLead()) {
          writeLead({ dismissed: true });
        }
      }
      syncExitIntent();
      if (lastFocus && lastFocus.focus) {
        lastFocus.focus();
      }
    }

    function open(declencheur) {
      lastFocus = document.activeElement;
      sheet.hidden = false;
      sheet.classList.add('is-open');
      track('pro_lead_capture_shown', {
        declencheur: declencheur || 'articles',
        nb_articles: listTotals().totalQty
      });
      var first = sheet.querySelector('input');
      if (first) {
        first.focus();
      }
    }

    sheet.querySelectorAll('[data-lead-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        close('dismissed');
      });
    });

    sheet.addEventListener('click', function (event) {
      if (event.target === sheet) {
        close('dismissed');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !sheet.hidden) {
        close('dismissed');
      }
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var societe = form.querySelector('[name="societe"]');
        var telephone = form.querySelector('[name="telephone"]');
        var valeurSociete = societe ? societe.value : '';
        var valeurTelephone = telephone ? telephone.value.trim() : '';
        var verdict = leadChampsValides(valeurSociete, valeurTelephone);
        var societeOk = verdict.societeOk;
        var phoneOk = verdict.telephoneOk;

        if (societe) {
          societe.closest('.redesk-pro-list__field').classList.toggle('is-invalid', !societeOk);
        }
        if (telephone) {
          telephone.closest('.redesk-pro-list__field').classList.toggle('is-invalid', !phoneOk);
        }

        if (msg) {
          msg.hidden = true;
        }
        if (!societeOk || !phoneOk) {
          if (msg) {
            msg.textContent = !societeOk
              ? 'Merci d\'indiquer votre société.'
              : valeurTelephone === ''
                ? 'Merci d\'indiquer un numéro de téléphone pour le rappel.'
                : 'Ce numéro de téléphone ne semble pas valide.';
            msg.className = 'redesk-pro-list__sheet-msg redesk-pro-list__sheet-msg--err';
            msg.hidden = false;
          }
          return;
        }

        var lead = {
          societe: valeurSociete.trim(),
          telephone: valeurTelephone
        };
        soumise = true;
        // Enregistré localement d'abord : même sans webhook, le formulaire final
        // sera prérempli et le pro n'aura pas saisi pour rien.
        writeLead(lead);

        // Totaux via listTotals() : renderRecap() repeindrait le récap pour rien.
        var etat = listTotals();
        // Tracké avant l'envoi, et quel que soit le sort du webhook : on mesure
        // une intention de laisser ses coordonnées, pas la santé de n8n.
        track('pro_lead_capture_submit', {
          societe: lead.societe,
          telephone_fourni: lead.telephone !== '',
          nb_articles: etat.totalQty
        });

        if (!webhook) {
          close('saved');
          return;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
        }
        // Même piège que sur le devis : les deux payloads doivent le porter,
        // sinon le robot passe simplement par l'autre porte.
        var piege = form.querySelector('[name="website"]');
        fetch(webhook, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            demande_id: 'lead-' + Date.now().toString(36) + '-' +
              Math.random().toString(36).slice(2, 8),
            type: 'lead_partiel',
            website: piege ? piege.value : '',
            contact: lead,
            total_ht: etat.totalHt,
            nb_articles: etat.totalQty,
            page_url: buildListUrl(),
            attribution: attributionDevis()
          })
        })
          .then(function (reponse) {
            if (!leadSubmitEnregistre(reponse)) {
              throw new Error('lead refuse par le serveur');
            }
            close('saved');
          })
          .catch(function () {
            /* Le lead reste en local, donc le devis sera prérempli, mais on ne
               prétend pas qu'il est arrivé : le serveur ne l'a pas accepté.
               Non bloquant, la feuille reste refermable et la liste intacte. */
            if (msg) {
              msg.textContent = 'Impossible d\'enregistrer ces informations pour le moment. ' +
                'Elles sont gardées sur cet appareil et rempliront votre devis, ' +
                'vous pouvez continuer votre liste.';
              msg.className = 'redesk-pro-list__sheet-msg redesk-pro-list__sheet-msg--err';
              msg.hidden = false;
            }
          })
          .then(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
            }
          });
      });
    }

    return { open: open, close: close, isOpen: function () { return !sheet.hidden; } };
  }

  function init() {
    var section = document.querySelector('.redesk-pro-list');
    if (!section) {
      return;
    }
    // Interactions dont le DOM existe des le chargement (independant du catalogue).
    initRecapInteractions();
    initRecapPanel(section);
    leadSheet = initLeadSheet(section);
    initQuoteSheet(section);
    initPeek(section);
    renderRecap();
    // Une liste reprise d'une visite précédente mérite le même filet.
    syncExitIntent();
    // Catalogue charge en AJAX, puis cablage steppers/ajout/filtres.
    initCatalog(section);
  }

  window.redeskProList = {
    addItem: addItem,
    removeItem: removeItem,
    renderRecap: renderRecap,
    setQty: setQty
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
